module.exports = __webpack_public_path__ + "static/media/blur_product_category.6e571120.jpg";